import { makeStyles, type DefaultTheme } from '@mui/styles';

type MakeStylesProps = {
  marginTop: number;
};

export const useStyles = makeStyles<DefaultTheme, MakeStylesProps>(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  (theme: any) => ({
    generalGroupHeader: {
      color: theme.palette.main,
      marginTop: ({ marginTop }) => (marginTop ? `${marginTop}px` : '')
    },
    generalGroupHeaderWrapper: {
      width: '100%'
    },
    divider: {
      backgroundColor: theme.palette.gray.superLight,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(3)
    },
    tooltip: {
      marginLeft: theme.spacing(2)
    }
  })
);
